import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M0 0v7.247C0 12.927 3.803 16.5 9 18c5.198-1.5 9-6.289 9-11.969V0H0zm16.8 6.031c0 4.871-3.191 9.228-7.803 10.716-3.062-.955-7.797-3.417-7.797-9.5V1.2h15.6v4.831zm-2.94-1.15l-.849-.848-5.667 5.666-2.355-2.354-.849.849 3.204 3.202 6.516-6.515z" />
  </svg>
);

export default SvgComponent;
